import { useParams } from 'react-router'
import WatermarksPage from './watermarks'
import MySettingsPage from './my-settings'
import PropertiesPage from './properties'
import DocumentTypesPage from './document-types'
import FolderTypesPage from './folder-types'
import WorkflowTemplatesPage from './workflow-templates'
import FolderStructureTemplateTypesPage from './folder-structure-template-types'
import TagsPage from './tags'

const Settings = () => {
  const { settingsTab = '' } = useParams<{ settingsTab: string }>()

  // Route to specific settings pages
  if (settingsTab === 'watermarks') {
    return <WatermarksPage />
  }

  if (settingsTab === 'my-settings' || settingsTab === 'my-edge-rcm') {
    return <MySettingsPage />
  }

  if (settingsTab === 'metadata') {
    return <PropertiesPage />
  }

  if (settingsTab === 'document-types') {
    return <DocumentTypesPage />
  }

  if (settingsTab === 'folder-types') {
    return <FolderTypesPage />
  }

  if (settingsTab === 'workflow-templates') {
    return <WorkflowTemplatesPage />
  }

  if (settingsTab === 'folder-structure-template-types') {
    return <FolderStructureTemplateTypesPage />
  }

  if (settingsTab === 'tags') {
    return <TagsPage />
  }

  const title = settingsTab || 'Settings'

  return <div>{title}</div>
}

export default Settings
